import React, { useEffect, useState } from "react";
import "./Profile.scss";
import CustomTextField from "../../TextFiled/Index"; // assuming this is your custom text field component
import {
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { IoIosCamera, IoMdImage } from "react-icons/io";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Header from "../Home/Header/Header";
import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";
import { FaRegBuilding } from "react-icons/fa";
import { MdEmail, MdOutlineAccountCircle } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import Cookies from "js-cookie";

const Profile = () => {
  const [profilePicture, setProfilePicture] = useState(null);
  const [allProfileData, setAllProfileData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
  };

  useEffect(() => {
    const storedProfileData = sessionStorage.getItem("profileData");
    if (storedProfileData) {
      setIsLoading(false);
      setAllProfileData(JSON.parse(storedProfileData));
    }
    //  else {
    //   CommonAPImain("UserDetail")
    //     .then((response) => {
    //       if (response?.Status == 200) {
    //         setIsLoading(false);
    //         setAllProfileData(response?.Data?.DT[0]);
    //         const profileData = response?.Data?.DT[0];
    //         sessionStorage.setItem("profileData", JSON.stringify(profileData));
    //         setIsLoading(false);
    //       }
    //     })
    //     .catch((err) => console.log(err));
    // }
  }, []);

  const handleProfilePictureChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePicture(URL.createObjectURL(file));
    }
  };

  const handleLogoutConfirm = () => {
    setOpenLogoutDialog(false);
    sessionStorage.removeItem("profileData");
    Cookies.remove("device_token");
    Cookies.remove("token");
    Cookies.remove("SV");
    navigate("/logout", { replace: true });
  };

  const handleLogoutCancel = () => {
    setOpenLogoutDialog(false);
  };

  const HandleDeleteAccount = async () => {
    sessionStorage.clear();
    window.location.reload();
    // navigate("/account-delete", { replace: true });
    window.history.pushState({}, "", "/account-delete");
  };

  const HandleDeleteAccountOpen = () => {
    setOpenDeleteDialog(true);
  };

  const handleDeleteCancel = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <div className="profile_main_div">
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <div className="Common_header">
        <Button className="backErrowButton">
          <IoChevronBackOutline
            style={{ height: "27px", width: "27px", color: "black" }}
            onClick={() => navigate("/")}
          />
        </Button>
        <p className="common_header_title">Profile</p>
      </div>
      {/* <Header otherPage={true} title="Profile" /> */}
      <Dialog open={openDeleteDialog} onClose={handleDeleteCancel}>
        <DialogTitle>Are you sure you want to delete your account?</DialogTitle>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleDeleteCancel}
            className="Account_delete_button"
          >
            Cancel
          </Button>
          <Button
            onClick={HandleDeleteAccount}
            autoFocus
            className="Account_delete_button"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLogoutDialog}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-confirmation-dialog"
      >
        <DialogTitle id="logout-confirmation-dialog">
          Are you sure you want to logout?
        </DialogTitle>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleLogoutCancel}
            className="Account_delete_button"
          >
            No
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            className="Account_delete_button"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {!isLoading && (
        <div>
          <div className="profile-container" style={{ padding: "30px 20px" }}>
            <div
              className="profile-picture"
              style={{
                textAlign: "center",
                marginBottom: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={
                    allProfileData?.ImagePath ||
                    "https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI="
                  }
                  alt="Profile"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                  }}
                />

                <div className="profileFiled_div_name">
                  <label className="profile_textfile_label_value_name">
                    {allProfileData?.firstname} {allProfileData?.lastname}
                  </label>
                  <label className="profile_textfile_label_value_UserID">
                    {allProfileData?.UserID}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="profile_deatil_top_main">
            {allProfileData && (
              <div className="profile_deatil_top">
                {allProfileData?.DefCompanyName && (
                  <div className="profileFiled_div">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FaRegBuilding
                        style={{ height: "20px", width: "20px" }}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label className="profile_textfile_label_value">
                        {allProfileData?.DefCompanyName} (
                        {allProfileData?.CompanyCode})
                      </label>
                    </div>
                  </div>
                )}

                {allProfileData?.Email && (
                  <div className="profileFiled_div">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <MdEmail style={{ height: "20px", width: "20px" }} />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label className="profile_textfile_label_value">
                        {allProfileData?.Email}
                      </label>
                    </div>
                  </div>
                )}

                {allProfileData?.MobileNo && (
                  <div className="profileFiled_div_last">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <FaPhoneAlt style={{ height: "20px", width: "20px" }} />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label className="profile_textfile_label_value">
                        {allProfileData?.MobileNo}
                      </label>
                    </div>
                  </div>
                )}

                <div className="profileFiled_div_last_Delete">
                  <div
                    className="profileFiled_div_last_Delete_sub"
                    onClick={HandleDeleteAccountOpen}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <MdOutlineAccountCircle
                        style={{
                          height: "20px",
                          width: "20px",
                          color: "white",
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label
                        className="profile_textfile_label_value"
                        style={{ color: "white" }}
                      >
                        DELETE MY ACCOUNT
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="profile_logoutBtn_div">
            <Button
              variant="contained"
              className="profile_logout_btn"
              onClick={handleLogoutClick}
            >
              Logout
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
